// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"378":"site","604":"company","884":"admin"}[chunkId] + "." + {"378":"7c80b63e","604":"d323f0f6","884":"ed641a53"}[chunkId] + ".css";
};